import { render, staticRenderFns } from "./MpSevkiyat.vue?vue&type=template&id=3c92b488&scoped=true"
import script from "./MpSevkiyat.vue?vue&type=script&lang=js"
export * from "./MpSevkiyat.vue?vue&type=script&lang=js"
import style0 from "./MpSevkiyat.vue?vue&type=style&index=0&id=3c92b488&prod&lang=scss&scoped=true"
import style1 from "./MpSevkiyat.vue?vue&type=style&index=1&id=3c92b488&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c92b488",
  null
  
)

export default component.exports